<template>
  <router-link
    :to="{ name: 'CategoryShow', params: { slug: category.slug } }"
    class="flex space-x-4 bg-gray-100 border border-gray-200 rounded-xl p-2 shadow-md transition bg-gradient bg-gradient-to-b from-teal-50 to-emerald-50 hover:opacity-70"
  >
    <img :src="category.image" :alt="category.name_en" class="w-[100px]" />
    <div class="flex items-center">
      <div>
        <h2 class="text-lg text-gray-700 font-bold">
          {{ category.name_vi }}
        </h2>
        <span class="text-gray-600 italic">{{ category.word_count }} từ vựng</span>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
  defineProps<{
    category: {
      type: object
      required: true
    }
  }>()
</script>
